import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const BoletaSalidaApi = () => {
    const [cargando, setCargando] = useState(false);

    const getSalidaBodega = async (id) => {
        try {
            setCargando(true);
            const response = await api.get(`prod_bodega_salidas/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getSalidaBodega,

        cargando,
    };
};
